import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';

import { LandingModule } from './landing/landing.module';

@NgModule({
  imports: [
    CommonModule,
    LandingModule,
    SharedModule,
  ],
  declarations: []
})
export class LandingPageModule { }
